export const ReportTable = ({ item }: { item: any }) => {
  let tableHeader: Array<string> = []
  Object.keys(item).forEach(ii => {
    tableHeader.push(ii)
  })
  const columnWidth = `calc(100% / ${tableHeader.length - 2})`
  return (
    <div className="mt-5">
      <div className='flex bg-amber-400 text-center'>
        {tableHeader.map((headerItem, indexKey) => {
          return (
            <div
              style={{ width: headerItem === "name" || headerItem === "code" ? "10%" : columnWidth }}
              key={"table_header_item_" + indexKey}
              className={`border-slate-600 ${indexKey + 1 !== tableHeader.length ? "border-l" : ""} p-3`}
            >{item[headerItem].display_name}</div>
          )
        })}
      </div>
      <div className='flex bg-gray-700 text-white text-center'>
        {tableHeader.map((bodyItem, indexKey) => {
          const borderColumn = indexKey + 1 !== tableHeader.length ? "border-l" : ""
          if (Array.isArray(item[bodyItem].value)) {
            return (
              <div key={'item_of_column_' + indexKey} style={{ width: bodyItem === "name" || bodyItem === "code" ? "10%" : columnWidth }} className={`border-slate-600 ${borderColumn} py-3`}>{
                item[bodyItem].value.map((countItem: any, index: number) => {
                  return (
                    <div
                      style={{ backgroundColor: countItem.color === "#FFFFFF" ? "#374151" : countItem.color }}
                      className={`flex justify-between px-4 border-b border-slate-600 py-3 text-sm`}
                      key={"count_item_" + bodyItem + index}
                    >
                      <div>{countItem.name}</div>
                      <div className="px-2 py-1 rounded-md">{countItem.count}</div>
                    </div>
                  )
                })
              }</div>
            )
          }
          return (
            <div key={'item_of_column_' + indexKey} style={{ width: bodyItem === "name" || bodyItem === "code" ? "10%" : columnWidth }} className={`border-slate-600 ${borderColumn} p-3`}>{item[bodyItem].value}</div>
          )
        })}
      </div>
    </div>
  )
}